import { render, staticRenderFns } from "./IdToNameRedirection.vue?vue&type=template&id=c1f4c9c2"
import script from "./IdToNameRedirection.vue?vue&type=script&lang=js"
export * from "./IdToNameRedirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports